import {
  Redemption,
  RedemptionDto,
  RedemptionListFilters,
  RedemptionListFiltersDto,
  RedemptionStatusDtoEnum,
  RedemptionStatusEnum,
} from '~/models/Redemption';

type StatusDtoKey = keyof typeof RedemptionStatusDtoEnum;
type StatusKey = keyof typeof RedemptionStatusEnum;

export class RedemptionAdapter {
  static toView(data: RedemptionDto): Redemption {
    return new Redemption({
      redemptionId: `#${data.id}`,
      status: RedemptionStatusEnum[RedemptionStatusDtoEnum[data.status as StatusDtoKey]],
      amount: convertToBrCurrency(data.value),
      createdAt: new Date(data.createdAt),
    });
  }
}

export class RedemptionListFiltersAdapter {
  static toDto(data: RedemptionListFilters): RedemptionListFiltersDto {
    const filtersDto = new RedemptionListFiltersDto();

    if (!data.date.length) {
      filtersDto.StartDate = undefined;
      filtersDto.EndDate = undefined;
    } else if (data.date.at(0)) {
      filtersDto.StartDate = formatToISODate(data.date.at(0));
      filtersDto.EndDate = !data.date.at(1)
        ? formatToISODate(data.date.at(0))
        : formatToISODate(data.date.at(1));
    }

    filtersDto.Status =
      (RedemptionStatusDtoEnum[data.status] as unknown as string) ?? undefined;

    filtersDto.Value = (() => {
      try {
        const value = formatBrCurrencyToNumber(data.amount);
        if (!value) return undefined;
        return value;
      } catch (err) {
        console.error(err);
        return undefined;
      }
    })();

    filtersDto.ID = (() => {
      // Return undefined if redemptionId is not provided
      // or if it doesn't start with a hash
      if (!data.redemptionId) return undefined;
      // Remove the hash from the redemptionId
      const idWithoutHash = data.redemptionId.replace('#', '');
      if (isNaN(Number(idWithoutHash))) return undefined;

      // Check if it's a numeric string and has less than 6 digits
      if (/^\d+$/.test(idWithoutHash) && idWithoutHash.length < 6) {
        return idWithoutHash.padStart(6, '0');
      }
      return idWithoutHash;
    })();

    return filtersDto;
  }
}
